import { SalesDespatchItemDetails } from './sales-despatch-item-details';

export interface SalesPackDetails {
  id: string;
  packNo: number;
  orderNo: string;
  orderType: string;
  customerId: string;
  customerKey: string;
  customerName: string;
  customerAddressMultiLine: string;
  deliveryAddressMultiLine: string;
  deliveryDate: Date;
  productId: string;
  productKey: string;
  productDescription: string;
  grossQuantity: number;
  nettQuantity: number;
  tare: number;
  height: number;
  width: number;
  depth: number;
  packTypeId: string;
  packTypeKey: string;
  packTypeDescription: string;
  datePacked: Date;
  packedBy: string;
  notes: string;
  customerPackNo: string;
  shipperSupplierId: string;
  shippingPackId: string;
  shippingPackKey: string;
  shippingPackDescription: string;

  salesDespatchItems: SalesDespatchItemDetails[];
}
